import { Injectable, inject } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { Auth } from "@angular/fire/auth";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  private auth = inject(Auth);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      // Check if user is already available (auth already initialized)
      const currentUser = this.auth.currentUser;
      if (currentUser) {
        console.log(
          "AuthGuard: User already authenticated:",
          currentUser.email,
        );
        subscriber.next(true);
        subscriber.complete();
        return;
      }

      // Wait for Firebase Auth to initialize
      const unsubscribe = this.auth.onAuthStateChanged((user) => {
        console.log(
          "AuthGuard: onAuthStateChanged fired, user:",
          user?.email || "null",
        );
        if (user) {
          // User is authenticated
          subscriber.next(true);
        } else {
          // User is not authenticated, redirect to login
          console.log("AuthGuard: No user, redirecting to login");
          this.router.navigate(["/login"]);
          subscriber.next(false);
        }
        subscriber.complete();
        unsubscribe();
      });
    });
  }
}
